import StudiesPage from './ui/studies/studies';

export default StudiesPage;
